import { useRouter } from 'next/router';
import { useGetSeoPageQuery } from '../services/seoApi';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { selectRegion } from '@redux/slices/header';
import { useEffect, useState } from 'react';
import { getSsrSeoData, seoActions } from '@entities/Seo';
import { getStrParams } from '@entities/Filter';
import { useSmartQuery } from '@shared/hooks/useSmartQuery';

export const useSeoCatalog = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const strParams = useAppSelector(getStrParams);
  const ssrSeoData = useAppSelector(getSsrSeoData);
  const [currentUrl, setCurrentUrl] = useState<{ url: string; params: string }>({
    url: router.asPath,
    params: strParams,
  });
  const { REGION: regionId } = useAppSelector(selectRegion);

  const { data, isFetching } = useSmartQuery({
    queryHook: useGetSeoPageQuery,
    params: { regionId: +regionId, slug: currentUrl.url || router.asPath },
    initialData: ssrSeoData,
  });

  useEffect(() => {
    if (!isFetching) {
      dispatch(seoActions.setSeoData(data));
    }
  }, [isFetching, data]);

  useEffect(() => {
    setCurrentUrl({
      url: window.location.pathname + window.location.search,
      params: strParams,
    });
  }, [strParams]);
};
